const videoExtensions = [".mp4", ".mov", ".avi", ".mkv"];

export function CheckIsVideoFile(fileName: string) {
  fileName = fileName.toLowerCase();
  return videoExtensions.some((extension) => fileName.endsWith(extension));
}
